// extracted by mini-css-extract-plugin
export default {"Content":"App_Content__UcW5X"};